import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faPlay } from "@fortawesome/free-solid-svg-icons";
import { formatLocalDate, formatFileSize } from "./format";
import openRecordingModal from "./openRecordingModal";

const PendingBanner = ({ count }) => (
  <div className="rec-pending-banner">
    <div className="spinner spinner-sm" />
    <span>
      You have {count} recording{count === 1 ? "" : "s"} that need
      {count === 1 ? "s" : ""} to be processed before viewing.
    </span>
  </div>
);

const RecordingsPane = ({
  recordings,
  isLoading,
  error,
  pendingCount = 0,
  onRetry,
}) => {
  if (isLoading) {
    return (
      <div className="loading-state">
        <div className="spinner" />
        <div>Loading…</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="ch-error">
        {error}
        {onRetry && (
          <div style={{ marginTop: 8 }}>
            <button type="button" className="ch-refresh-btn" onClick={onRetry}>
              Retry
            </button>
          </div>
        )}
      </div>
    );
  }

  const list = Array.isArray(recordings) ? recordings : [];

  if (list.length === 0 && pendingCount === 0) {
    return (
      <div className="empty-state">
        <div className="es-msg">
          No recordings available for this session or may have been deleted by your Admin.
        </div>
      </div>
    );
  }

  return (
    <div>
      {pendingCount > 0 && <PendingBanner count={pendingCount} />}
      {list.length > 0 && (
        <table className="ch-table ch-table-rec">
          <thead>
            <tr>
              <th>File Name</th>
              <th>Created</th>
              <th>Size</th>
              <th className="ch-th-actions" aria-label="Actions" />
            </tr>
          </thead>
          <tbody>
            {list.map((rec, i) => {
              const url = rec.fileUrl || rec.filePath || "";
              const name = rec.fileName || `Recording ${i + 1}`;
              const date = formatLocalDate(rec.createDateTime || rec.createdAt);
              const size = formatFileSize(rec.size ?? rec.fileSize);
              return (
                <tr key={url || i}>
                  <td className="ch-td-name" title={name}>
                    {url ? (
                      <button
                        type="button"
                        className="ch-name-btn"
                        onClick={() => openRecordingModal(url, name)}
                      >
                        <span className="ch-file-name">{name}</span>
                      </button>
                    ) : (
                      <span className="ch-file-name">{name}</span>
                    )}
                  </td>
                  <td className="ch-td-date">{date}</td>
                  <td className="ch-td-size">{size}</td>
                  <td className="ch-td-actions">
                    {url && (
                      <div className="ch-actions">
                        <button
                          type="button"
                          className="ch-action"
                          title="Play recording"
                          aria-label="Play recording"
                          onClick={() => openRecordingModal(url, name)}
                        >
                          <FontAwesomeIcon icon={faPlay} className="ch-action-icon" />
                          <span className="ch-action-label">Play</span>
                        </button>
                        <a
                          href={url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="ch-action"
                          title="Download recording"
                          aria-label="Download recording"
                          download
                        >
                          <FontAwesomeIcon icon={faDownload} className="ch-action-icon" />
                          <span className="ch-action-label">Download</span>
                        </a>
                      </div>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default RecordingsPane;
